import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { PageViewedEventSchema } from '../../schemas/page/PageViewedEventSchema'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { EVENT_CATEGORY } from '../../constants/EventHelper'

export interface PageViewedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL?: string | null
  EVENT_CATEGORY?: string | null
}

export class PageViewedEvent extends AnalyticsEvent {
  constructor(params: PageViewedEventParams) {
    super(PageViewedEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export async function trackPageViewedEvent(): Promise<void> {
  try {
    const { isEnabled = false } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_ONE) || {}
    if (isEnabled) {
      const commonParams = getCommonParams()
      const params: PageViewedEventParams = {
        ...commonParams,
      }
      if (commonParams.SCREEN_NAME === 'account | all') {
        params.BUSINESS_VERTICAL = null
        params.EVENT_CATEGORY = EVENT_CATEGORY.ACCOUNT
      }
      new PageViewedEvent(params).track()
    }
  } catch (error) {
    console.error('Error tracking page viewed event:', error)
  }
}
